import Loading2 from "../../utils/Loader/Loading2";

const LoaderLayout = ({ children, isPending }) => {
  return <div>{isPending ? <Loading2 /> : <div>{children}</div>}</div>;
};

export default LoaderLayout;
